
function PockliPolicyPage() {
  const contactEmail = "vortaxgamestudio@gmail.com";

  return (
    <section className="policy-page">
      <p className="eyebrow">Privacy Policy</p>

      <h1>Pockli Privacy Policy</h1>

      <p className="subtitle">
        Last updated: October 25, 2026
      </p>

      <p className="content policy-intro">
        Pockli is a personal finance management application
        that helps users track income, expenses, wallets,
        budgets, and debts.
        This Privacy Policy explains how Pockli handles
        financial information, device data, and optional
        Google Drive backup functionality.
      </p>

      <div className="policy-grid">

        <article className="policy-card">
          <h3>1. Financial Information</h3>
          <p>
            Pockli allows users to enter and manage financial
            information, including transactions, balances,
            wallets, categories, budgets, debts, and related
            records.
          </p>
          <p>
            Financial records are stored locally on the
            user's device. Pockli does not require users
            to create a Pockli account to manage their
            finances.
          </p>
        </article>

        <article className="policy-card">
          <h3>2. Google Drive Backup</h3>
          <p>
            Pockli offers optional Google Drive backup and
            restore functionality.
          </p>
          <p>
            If a user chooses to connect a Google account,
            Pockli requests the Google Drive permissions
            necessary to create, access, and manage its
            own application backup files.
          </p>
          <p>
            Backup data is stored in the user's Google Drive
            application data storage area. Pockli does not
            request general access to unrelated files
            stored in Google Drive.
          </p>
          <p>
            Google Drive backup is optional. Users can
            use Pockli without connecting a Google account.
          </p>
        </article>

        <article className="policy-card">
          <h3>3. Google Account Information</h3>
          <p>
            When Google Drive backup is enabled, Google
            authentication is used to authorize access
            to the application's backup storage.
          </p>
          <p>
            Google authentication credentials are used
            only for the authorized integration and
            are not sold or used for advertising.
          </p>
        </article>

        <article className="policy-card">
          <h3>4. How Information Is Used</h3>
          <p>
            Information entered into Pockli is used to
            provide personal finance features, calculate
            balances, display reports, manage budgets,
            and track debts.
          </p>
          <p>
            When enabled, Google Drive access is used
            to back up and restore application data.
          </p>
        </article>

        <article className="policy-card">
          <h3>5. Data Storage and Security</h3>
          <p>
            Pockli stores financial records on the user's
            device. Optional backup files are stored in
            the user's Google Drive account.
          </p>
          <p>
            We aim to protect user information through
            appropriate application safeguards. However,
            no electronic storage or transmission method
            can be guaranteed to be completely secure.
          </p>
        </article>

        <article className="policy-card">
          <h3>6. Advertising and Data Sales</h3>
          <p>
            Pockli does not sell users' personal or
            financial information.
          </p>
          <p>
            Pockli does not use financial records for
            advertising purposes.
          </p>
        </article>

        <article className="policy-card">
          <h3>7. Data Sharing</h3>
          <p>
            Pockli does not share users' financial records
            with advertisers or data brokers.
          </p>
          <p>
            If a user enables Google Drive backup, the
            information required for that functionality
            is processed through Google's services
            according to the user's authorization.
          </p>
        </article>

        <article className="policy-card">
          <h3>8. Data Retention and Deletion</h3>
          <p>
            Users can manage and delete financial records
            using the application's available features.
          </p>
          <p>
            Locally stored data may also be removed when
            the application is uninstalled or its storage
            is cleared.
          </p>
          <p>
            Google Drive backups may remain in the user's
            Google account after uninstalling Pockli.
            Removing local data does not automatically
            delete existing cloud backups.
          </p>
        </article>

        <article className="policy-card">
          <h3>9. Children's Privacy</h3>
          <p>
            Pockli is intended for personal finance
            management and is not specifically directed
            toward children.
          </p>
        </article>

        <article className="policy-card">
          <h3>10. Changes to This Policy</h3>
          <p>
            We may update this Privacy Policy to reflect
            changes in the application's features,
            integrations, or legal requirements.
          </p>
          <p>
            Updated versions will be published on
            this page with a revised update date.
          </p>
        </article>

        <article className="policy-card">
          <h3>11. Contact</h3>
          <p>
            For questions, privacy requests, or concerns
            about Pockli, please contact:
          </p>

          <p>
            <a href={`mailto:${contactEmail}`}>
              {contactEmail}
            </a>
          </p>
        </article>

      </div>
    </section>
  );
}

export default PockliPolicyPage;
